<template>
  <div class="header">
    <img class="img" @click="backRouter" :src="back" alt="" />
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
import back from '@/operationViews/assets/img/back.png'
export default {
  data() {
    return {
      title: '',
      back
    }
  },
  watch: {
    $route: {
      handler: function (val) {
        this.title = val.meta.title
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  methods: {
    backRouter() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.header {
  align-items: center;
  width: 100%;
  height: 44px;
  box-sizing: border-box;
  display: flex;
  position: fixed;
  padding: 10px 12px;
  border-bottom: 1px solid #eee;
  background: #ffffff;
  top: 0px;
  left: 0px;
  z-index: 999;
}

.img {
  width: 24px;
  height: 24px;
}

.title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-weight: 500;
  font-size: 16px;
  color: #192637;
}
</style>



// WEBPACK FOOTER //
// src/operationViews/Layout/components/header.vue